import { useSessionStore } from '@/store/sessionStore';
import { cmd } from '@/session/sessionRuntime';
import { useCountdown, formatMs } from '@/hooks/useCountdown';

export function WordPickView(): JSX.Element {
  const self = useSessionStore((s) => s.self);
  const deadline = useSessionStore((s) => s.phaseDeadlineAt);
  const candidateWords = useSessionStore((s) => s.candidateWords);
  const candidateCount = useSessionStore((s) => s.candidateCount);
  const remaining = useCountdown(deadline);

  const isChief = self?.isChief ?? false;
  const isWolf = self?.baseRole === 'wolf' || self?.role === 'wolf';
  const isSeer = self?.baseRole === 'seer' || self?.role === 'seer';
  const isInsider = isWolf || isSeer || isChief;

  return (
    <main
      data-testid="word-pick-view"
      className="mx-auto flex max-w-md flex-col gap-4 p-4"
    >
      <h1 className="text-center text-xl font-bold text-pig-700">选词阶段</h1>

      <div
        data-testid="word-pick-countdown"
        className="text-center text-sm text-gray-500"
      >
        剩余 {formatMs(remaining)}
      </div>

      {!isChief ? (
        <section
          data-testid="word-pick-wait"
          className="rounded-lg bg-white p-6 text-center shadow"
        >
          <div className="text-base font-semibold text-pig-700">等待村长选词…</div>
          <div className="mt-3 text-sm text-gray-500">
            候选词：{candidateCount || '—'} 个
          </div>
          <div className="mt-4 text-sm">
            {isInsider ? (
              <span className="text-amber-700">知情者提示：请准备</span>
            ) : (
              <span className="text-gray-700">村民：请准备提问</span>
            )}
          </div>
        </section>
      ) : (
        <section
          data-testid="chief-candidate-picker"
          className="rounded-lg bg-white p-4 shadow"
        >
          <div className="mb-2 text-sm font-semibold text-gray-700">
            候选词（{candidateWords?.length ?? 0}）
          </div>
          {candidateWords == null || candidateWords.length === 0 ? (
            <div className="py-6 text-center text-gray-400">等待候选词下发…</div>
          ) : (
            <ul className="space-y-2">
              {candidateWords.map((w) => (
                <li
                  key={w.id}
                  className="flex items-center justify-between rounded border border-gray-100 px-3 py-2"
                >
                  <span className="text-lg font-medium">{w.text}</span>
                  <button
                    data-testid={`confirm-word-${w.id}`}
                    onClick={() => cmd.confirmWord(w.id)}
                    className="rounded bg-pig-600 px-3 py-1 text-sm font-semibold text-white"
                  >
                    确认
                  </button>
                </li>
              ))}
            </ul>
          )}
          <button
            data-testid="reroll-candidates-btn"
            onClick={() => cmd.rerollCandidates()}
            className="mt-3 h-10 w-full rounded border border-pig-300 text-sm text-pig-700"
          >
            重抽一组
          </button>
        </section>
      )}
    </main>
  );
}
